module.exports = __webpack_public_path__ + "img/img-3.370b44d2.jpg";